/**
 * @generated SignedSource<<cd9ba26ad5993e2dfe57403e62f23e75>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespNullSearchResults_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRecommendedItems_viewer" | "SharedRecentSales_viewer" | "SharedYMAL_viewer">;
  readonly " $fragmentType": "SbRespNullSearchResults_viewer";
};
export type SbRespNullSearchResults_viewer$key = {
  readonly " $data"?: SbRespNullSearchResults_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespNullSearchResults_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespNullSearchResults_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRecommendedItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRecentSales_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedYMAL_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "94f4e52eb9e94bdd18a3646362d5c5ab";

export default node;
